class PersistedStorage {
  public setItem (key: string, value: string): void {
    localStorage.setItem(key, value)
  }
  
  public getItem (key: string): string | null {
    return localStorage.getItem(key)
  }
  
  public removeItem (key: string): void {
    return localStorage.removeItem(key)
  }
}

const persistedStorage = new PersistedStorage()

export function usePersistedStorage () {
  return {
    persistedStorage
  }
}